module.exports = __webpack_public_path__ + "img/icon_media@2x.b7fa6d2f.png";